import { create } from "zustand";
import { API_URL } from "../Config/config";
import axiosInstance from "../services/axiosInstance";

const useSummaryStore = create((set, get) => ({
    fetchSummary: async (body) => {
        try {

            let URL = API_URL + "order/order-summary";

            const result = await axiosInstance.post(URL,{...body});
            const response = result.data;

            if (response.message == "success") {
                return { status: true, data: response };
            } else {
                return { status: false, data: response };
            }
        } catch (err) {
            return { status: false, data: err.response };
        }
    },
    fetchAdminSummary: async (body) => {
        console.log(body, 'body')
        try {

            let URL = API_URL + "order/admin-order-summary";

            const result = await axiosInstance.post(URL,body);
            const response = result.data;

            if (response.message == "success") {
                return { status: true, data: response };
            } else {
                return { status: false, data: response };
            }
        } catch (err) {
            return { status: false, data: err.response };
        }
    },
    summeryDownloadAdmin: async (filter) => {
        try {
            let URL = API_URL + "order/admin-order-summary-download"

            const result = await axiosInstance.post(URL,filter);
            const response = result.data
            return { status: true, data: response };
            
        } catch(e) {
            return { status: false, data: e.response };
        }
    },
    summeryDownloadDistr: async (filter) => {
        try {
            let URL = API_URL + "order/order-summary-download"

            const result = await axiosInstance.post(URL,filter);
            const response = result.data
            return { status: true, data: response };
            
        } catch(e) {
            return { status: false, data: e.response };
        }
    },  
}));

export { useSummaryStore };